import { View } from "./RemindersSnapshots.view";

export const Container = () => {
  return <View />;
};
